import { useTranslation } from 'next-i18next'
import { tm } from '@captaincause/ui/tm'
import type { Campaign } from '@captaincause/types'

interface DisabledMessageProps {
  campaign: Campaign
}

const getDisabledMessage = (campaign: Campaign) => {
  if (campaign?.is_used) {
    return 'is-used'
  }

  if (campaign?.is_saturated) {
    return 'is-saturated'
  }

  if (campaign?.is_preview) {
    return 'is-preview'
  }

  return undefined
}

export function DisabledMessage({ campaign }: DisabledMessageProps) {
  const { t } = useTranslation('give.page')
  const message = getDisabledMessage(campaign)

  if (!message) {
    return null
  }

  return (
    <span
      className={tm(
        'mt-6 block rounded-lg border px-4 py-2 text-center text-xs leading-snug',
        campaign.is_preview
          ? 'border-dark-orange bg-light-orange text-dark-orange'
          : 'border-dark-red bg-light-red text-dark-red',
      )}
    >
      {t(`donate.${message}`)}
    </span>
  )
}
